module.exports = __webpack_public_path__ + "img/accessory_hat_05.14464907.svg";